/** @format */
import { MarketCode } from '@toucan/config/markets';

import {
    CmsBasicPageData,
    Image,
    RichText,
    UrlSlugParamsType,
} from '@toucan/client/core/contentful';

export type UrlSlugReference = Record<string, string>;

export enum TypenameTemplatePath {
    PageHelp = '/cms/basic',
    LandingPage = '/cms/landing-page',
    Category = '/content/category',
    Article = '/content/article',
    Contact = '/help/contact',
}

export enum EntryType {
    INLINE = 'inline',
    BLOCK = 'block',
    HYPERLINK = 'hyperlink',
}

export type HelpPageContentQuery = {
    slug: string;
    market: MarketCode;
};

export type HelpPageContentResponse = {
    pageHelpCollection: { items: HelpPageContent[] };
};

export type HelpPageContent = Pick<
    CmsBasicPageData,
    'content' | '__typename' | 'sys'
>;

export enum LandingPageHeroRenderType {
    CURVE = 'CURVE',
    MAIN_MIDNIGHT = 'MAIN_MIDNIGHT',
    MAIN_MIDNIGHT_GRADIENT = 'MAIN_MIDNIGHT_GRADIENT',
    MAIN_SUSTAINABILITY_GRADIENT = 'MAIN_SUSTAINABILITY_GRADIENT',
}

export type LandingPageContent = {
    content: RichText | null;
};

export type LandingPageData = UrlSlugParamsType & {
    __typename: string;
    sys: {
        id: string;
    };
    title: string;
    description: string;
    heroImage: Image | null;
    heroButtonText: string | null;
    heroButtonLink: string | null;
    heroRenderType: LandingPageHeroRenderType;
    seoTitle: string | null;
    seoDescription: string | null;
    disableSearchEngineIndexing: boolean | null;
    enableTrustPilotWidgetInHero: boolean | null;
};

export type LandingPageDataResponse = {
    landingPageCollection?: {
        items?: LandingPageData[];
    };
};

export type LandingPageContentResponse = {
    landingPageCollection?: {
        items?: LandingPageContent[];
    };
};
